import aboutUsImage from '../../assets/jpg/softtwining-about-us.jpg'

export default class OurVisionContent {
  name = 'our-vision-page'
  slug = 'our-vision'
  title = `${this.name}.title`
  image = aboutUsImage
  imageMobile = aboutUsImage
  text = `${this.name}.text`
  whatWeDoButton = `${this.name}.what-we-do-button`
}
